import { BindAll } from 'lodash-decorators'
import { action, computed, observable } from 'mobx'
import { EnumApiShow, EnumApiSummary } from '@xt/client/api'
import { $service } from '@xt/client/experimental/request/service'
import { type BasicData, ActionData, RecordData } from './types'
import { type UserHomeworkResult, PageMeta, UserDairyResult } from '@xt/client/entities/content/types'
import { MomentSourceType } from '@xt/client/enums/moment'
import { EnumStudyCardType } from '@xt/client/enums/course/index'
import moment from 'moment'

@BindAll()
export class Summary {
  constructor() {}

  @observable courseId: string | number | null = null
  @observable basicData: BasicData | null = null
  @observable basicDataLoading: boolean = false
  @observable homeWorkStatus: PageMeta = { inited: false, isLoading: false, hasMore: true, page: 0, pageSize: 8, lastId: undefined }
  @observable homeWorkList: UserHomeworkResult[] = []
  @observable actionData: ActionData | null = null
  @observable actionDataLoading: boolean = false
  @observable dairyList: UserDairyResult[] = []
  @observable recordList: RecordData[] = []
  @observable qrcodeImg: string = ''

  @computed
  get isCommentCountMoreFive() {
    return this.actionData?.studyPartnerInteract && this.actionData?.studyPartnerInteract.commentCount >= 5
  }
  @computed
  get sharedModalData() {
    if (!this.basicData || !this.actionData) return

    return {
      courseName: this.basicData.courseName,
      userName: this.basicData.memberNickname,
      learnTime: this.basicData.startStudyTime,
      watchHour: this.totalWatchHour,
      submitCount: this.totalHomeworkSubmit,
      studyProcess: this.learnProcess,
      bmrcCount: this.actionData.momentCount,
      txhdCount: this.actionData.interactionCount,
      zjxbName: this.actionData.studyPartnerInteract.toMemberNickname,
      zjxbId: this.actionData.studyPartnerInteract.toMemberId
    }
  }
  @computed
  get isRecordListLengthFull() {
    return this.recordList.length > 3 ? true : false
  }
  @computed
  get mapBarConfig() {
    const length = this.basicData?.classhourWatchSummaries.length

    if (length === 22) {
      return {
        barWidth: 5,
        barRadius: 1,
        containerW: 278
      }
    } else if (length === 12) {
      return {
        barWidth: 7,
        barRadius: 1,
        containerW: 216
      }
    } else if (length === 7) {
      return {
        barWidth: 12,
        barRadius: 1,
        containerW: 204
      }
    } else if (length === 5) {
      return {
        barWidth: 14,
        barRadius: 1,
        containerW: 174
      }
    } else {
      return {
        barWidth: 5,
        barRadius: 1,
        containerW: 278
      }
    }
  }
  // actionData映射类名
  @computed
  get mapActionClass() {
    const bmrc = this.onMapActionClass(this.actionData ? this.actionData?.momentCount : 0)
    const txhd = this.onMapActionClass(this.actionData ? this.actionData?.interactionCount : 0)

    return {
      bmrc,
      txhd
    }
  }
  // 映射类名
  @computed
  get mapProcessClass(): {
    mapTitleClass: string
    mapMessageClass: string
  } {
    const count = this.basicData ? Math.ceil((this.basicData?.obtainedPointCount / this.basicData?.totalPointCount) * 100) : 0

    if (count === 0) {
      return {
        mapTitleClass: 'completion-status-0-10',
        mapMessageClass: 'completion-message-0-10'
      }
    } else if (1 <= count && count < 11) {
      return {
        mapTitleClass: 'completion-status-10-30',
        mapMessageClass: 'completion-message-10-30'
      }
    } else if (11 <= count && count < 31) {
      return {
        mapTitleClass: 'completion-status-30-50',
        mapMessageClass: 'completion-message-30-50'
      }
    } else if (31 <= count && count < 51) {
      return {
        mapTitleClass: 'completion-status-50-70',
        mapMessageClass: 'completion-message-50-70'
      }
    } else if (51 <= count && count < 71) {
      return {
        mapTitleClass: 'completion-status-70-80',
        mapMessageClass: 'completion-message-70-80'
      }
    } else if (71 <= count && count < 81) {
      return {
        mapTitleClass: 'completion-status-80-90',
        mapMessageClass: 'completion-message-80-90'
      }
    } else if (81 <= count && count < 91) {
      return {
        mapTitleClass: 'completion-status-90-95',
        mapMessageClass: 'completion-message-90-95'
      }
    } else if (91 <= count && count < 96) {
      return {
        mapTitleClass: 'completion-status-95-99',
        mapMessageClass: 'completion-message-95-99'
      }
    } else if (96 <= count && count < 100) {
      return {
        mapTitleClass: 'completion-status-99-100',
        mapMessageClass: 'completion-message-99-100'
      }
    } else if (count === 100) {
      return {
        mapTitleClass: 'completion-status-100',
        mapMessageClass: 'completion-message-100'
      }
    }
    return {
      mapTitleClass: 'completion-status-0-10',
      mapMessageClass: 'completion-message-0-10'
    }
  }
  @computed
  get barChartsData() {
    return this.basicData?.classhourWatchSummaries.map(el => {
      return {
        completed: el.playDuration,
        total: el.playbackDuration
      }
    })
  }
  // 折线图数据转换
  @computed
  get lineChartsData() {
    let count = 0
    return this.basicData?.classhourHomeworkSubmitSummaries.map(el => {
      count += el.submitCount
      return count
    })
  }
  // 提交作业总数
  @computed
  get totalHomeworkSubmit() {
    const totalSubmit = this.basicData?.classhourHomeworkSubmitSummaries.reduce((acc, el) => {
      return acc + el.submitCount
    }, 0)
    return totalSubmit ?? 0
  }
  // 观看直播/回放时长
  @computed
  get totalWatchHour() {
    const totalSecond = this.basicData?.classhourWatchSummaries.reduce((acc, el) => {
      return acc + el.playDuration
    }, 0)
    return (totalSecond ? totalSecond / (60 * 60) : 0).toFixed(1)
  }
  // 学习进度
  @computed
  get learnProcess() {
    return this.basicData ? Math.floor((this.basicData.obtainedPointCount / this.basicData.totalPointCount) * 100) : 0
  }
  // 间隔时间
  @computed
  get durationDay() {
    if (this.basicData) {
      const now = Date.now()
      const date = moment(now).isBefore(this.basicData.endStudyTime) ? now : this.basicData.endStudyTime
      const duration = moment(date).diff(this.basicData.startStudyTime, 'days')
      return duration > 0 ? duration : 0
    }
  }

  private onMapActionClass(count: number) {
    if (count === 0) {
      return 'text-img-0'
    } else if (0 < count && count <= 10) {
      return 'text-img-1-10'
    } else if (10 < count && count <= 20) {
      return 'text-img-11-20'
    } else if (20 < count && count <= 30) {
      return 'text-img-21-30'
    } else if (30 < count && count <= 40) {
      return 'text-img-31-40'
    } else if (40 < count && count <= 50) {
      return 'text-img-41-50'
    } else if (50 < count) {
      return 'text-img-50-more'
    }
    return 'text-img-0'
  }
  // 学习记录卡片映射
  public mapRecordCardComp(type: number) {
    switch (type) {
      case EnumStudyCardType.MaxLessonWatch:
        return 'MaxLessonWatchCard'
      case EnumStudyCardType.CompleteLiveWatch:
        return 'CompleteLiveWatchCard'
      case EnumStudyCardType.EarliestHomeworkSubmit:
        return 'EarliestHomeworkSubmitCard'
      case EnumStudyCardType.LatestHomeworkSubmit:
        return 'LatestHomeworkSubmitCard'
      case EnumStudyCardType.MaxWordsHomework:
        return 'MaxWordsHomeworkCard'
      case EnumStudyCardType.MaxInteraction:
        return 'MaxInteractionCard'
      case EnumStudyCardType.ContinuousSubmit:
        return 'ContinuousSubmitCard'
      case EnumStudyCardType.MaxComments:
        return 'MaxCommentsCard'
      case EnumStudyCardType.MaxLikes:
        return 'MaxLikesCard'
      case EnumStudyCardType.MaxCollects:
        return 'MaxCollectsCard'
      case EnumStudyCardType.CompleteStudyInTime:
        return 'CompleteStudyInTimeCard'
      case EnumStudyCardType.MaxCommentInteractions:
        return 'MaxCommentInteractionsCard'
      case EnumStudyCardType.MaxLikeInteractions:
        return 'MaxLikeInteractionsCard'
      case EnumStudyCardType.MaxBeLikedInteractions:
        return 'MaxBeLikedInteractionsCard'
      case EnumStudyCardType.MaxCollectInteractions:
        return 'MaxCollectInteractionsCard'
      case EnumStudyCardType.MaxStudyDuration:
        return 'MaxStudyDurationCard'
      case EnumStudyCardType.UninterruptedCourseWatch:
        return 'UninterruptedCourseWatchCard'
      case EnumStudyCardType.UninterruptedDailySubmit:
        return 'UninterruptedDailySubmitCard'
      default:
        return 'MaxLessonWatchCard'
    }
  }

  // 获取qrcode
  public async getAppletsQrcode(memberId) {
    const params = {
      page: 'pages/my/center/index',
      query: `memberId=${memberId}`,
      appletsType: 2,
      hyaline: true
    }

    const [error, data] = await $service({
      url: EnumApiShow.appletsQrcode,
      data: params,
      params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg'
      }
    })

    if (error) return

    const url = window.URL.createObjectURL(data)

    this.setQrcodeImg(url)
  }

  // 学习轨迹首次数据处理
  public handleOrderRecordData() {
    // 数据过滤
    const validEnumValues = Object.values(EnumStudyCardType)
    let filterData = this.recordList.filter(el => validEnumValues.includes(el.ruleType))

    // 授权重
    filterData = filterData.map(el => {
      let order: number = 0

      if (el.ruleType === EnumStudyCardType.MaxStudyDuration) {
        order = 9999
      } else if (el.ruleType === EnumStudyCardType.UninterruptedCourseWatch) {
        order = 999
      } else if (el.ruleType === EnumStudyCardType.UninterruptedDailySubmit) {
        order = 99
      } else {
        order = 1
      }

      return {
        ...el,
        order
      }
    })

    // 权重(降序排列)
    filterData.sort((a, b) => b.order! - a.order!)

    this.setRecordData(filterData)
  }

  // 学习小结页面初始化
  public pageInit(courseId: string | number) {
    this.setCourseId(courseId)
    this.fetchBasicDataByCourseId()
    this.fetchHomeworks()
    this.fetchActionData()
    this.fetchDairy()
    this.loadRecordData()
  }

  // 加载更多作业数据
  public loadMoreHomeworks() {
    this.fetchHomeworks()
  }

  public async loadRecordData() {
    await this.fetchRecordData()
    this.handleOrderRecordData()
  }

  /**
   * 点击卡片上的刷新按钮刷新
   * 策略：保证刷新的数据不在和已展示的内容重复即可
   */
  public onClickRefresh(index: number) {
    if (!this.isRecordListLengthFull) return

    let newList = [...this.recordList]
    let randIndex
    do {
      randIndex = Math.floor(Math.random() * newList.length)
    } while (randIndex === 0 || randIndex === 1 || randIndex === 2)
    ;[newList[index], newList[randIndex]] = [newList[randIndex], newList[index]]

    this.setRecordData(newList)
  }

  /** '换一批'-刷新学习轨迹数据
   * 策略：Fisher - Yates 洗牌算法
   */
  public refreshRecordData() {
    if (!this.isRecordListLengthFull) return

    let newList = [...this.recordList]
    for (let i = newList.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[newList[i], newList[j]] = [newList[j], newList[i]]
    }
    newList.slice(0, 3)
    this.setRecordData(newList)
  }

  private async fetchRecordData() {
    const [err, data] = await $service<RecordData[]>({
      method: 'GET',
      url: EnumApiSummary.Record,
      params: {
        sourceId: this.courseId,
        sourceType: MomentSourceType.SunDrying
      }
    })

    if (err) throw new Error('网络开小差了～')

    this.setRecordData(data)
  }

  private async fetchDairy() {
    const [err, data] = await $service<UserDairyResult[]>({
      method: 'GET',
      url: EnumApiSummary.Dairys,
      params: {
        sourceId: this.courseId,
        sourceType: MomentSourceType.SunDrying
      }
    })

    if (err) return

    this.setDairyMeta(data)
  }

  private async fetchActionData() {
    try {
      this.setActionDataLoading(true)
      const [err, data] = await $service<ActionData>({
        method: 'GET',
        url: EnumApiSummary.ActionData,
        params: {
          sourceId: this.courseId,
          sourceType: MomentSourceType.SunDrying
        }
      })

      if (err) return
      this.setActionData(data)
    } finally {
      this.setActionDataLoading(false)
    }
  }

  private async fetchHomeworks() {
    const { isLoading, page, pageSize, hasMore, inited, lastId } = this.homeWorkStatus

    if (isLoading) return

    if (!hasMore) return

    try {
      this.setHomeWorkStatus({
        isLoading: true
      })

      const [err, data] = await $service<UserHomeworkResult[]>({
        method: 'GET',
        url: EnumApiSummary.HomeWorks,
        params: {
          courseId: this.courseId,
          page: page + 1,
          pageSize,
          lastId
        }
      })

      if (err) return

      if (!inited) {
        this.setHomeWorkList(data)
      } else {
        this.appendHomeWorkList(data)
      }

      this.setHomeWorkStatus({
        inited: true,
        page: page + 1,
        hasMore: data.length === pageSize,
        lastId: data.length ? data[data.length - 1].id : lastId
      })
    } finally {
      this.setHomeWorkStatus({
        isLoading: false
      })
    }
  }

  private async fetchBasicDataByCourseId() {
    try {
      this.setBasicDataLoading(true)
      const [err, data] = await $service<BasicData>({
        method: 'GET',
        url: EnumApiSummary.BasicData,
        params: {
          courseId: this.courseId
        }
      })

      if (err) return

      this.setBasicData(data)
    } finally {
      this.setBasicDataLoading(false)
    }
  }

  @action
  private setQrcodeImg(url: string) {
    this.qrcodeImg = url
  }
  @action
  private appendHomeWorkList(data: UserHomeworkResult[]) {
    this.homeWorkList = [...this.homeWorkList, ...data]
  }
  @action
  private setRecordData(data: RecordData[]) {
    this.recordList = data
  }
  @action
  private setActionData(data: ActionData) {
    this.actionData = data
  }
  @action
  private setHomeWorkList(data: UserHomeworkResult[]) {
    this.homeWorkList = data
  }
  @action
  private setBasicData(data: BasicData) {
    this.basicData = data
  }
  @action
  private setCourseId(courseId: string | number) {
    this.courseId = courseId
  }
  @action
  private setActionDataLoading(loading: boolean) {
    this.actionDataLoading = loading
  }
  @action
  private setBasicDataLoading(loading: boolean) {
    this.basicDataLoading = loading
  }
  @action
  private setHomeWorkStatus(status: Partial<PageMeta>) {
    this.homeWorkStatus = {
      ...this.homeWorkStatus,
      ...status
    }
  }
  @action
  private setDairyMeta(list: UserDairyResult[]) {
    this.dairyList = list
  }

  // 关闭弹窗之后再打开需要 - 重置作业请求参数状态
  @action
  resetHomeWorkStatus() {
    this.homeWorkStatus = { inited: false, isLoading: false, hasMore: true, page: 0, pageSize: 8, lastId: undefined }
  }

  @action
  reset() {
    this.courseId = null
    this.basicData = null
    this.homeWorkList = []
    this.homeWorkStatus = { inited: false, isLoading: false, hasMore: true, page: 0, pageSize: 8, lastId: undefined }
    this.actionData = null
    this.dairyList = []
    this.recordList = []
  }
}
